import React, { PropsWithChildren } from "react";
import { Configure, ConfigureProps } from "react-instantsearch";
import {
  algoliaUserToken,
  isAlgoliaAnalyticsEnabled
} from "./algoliaAnalytics";

type Props = Omit<ConfigureProps, "analytics" | "userToken" | "clickAnalytics">;

const ConfiguredConfigure: React.FC<PropsWithChildren<Props>> = ({
  children,
  ...props
}) => {
  const isTrackingEnabled = isAlgoliaAnalyticsEnabled();
  const userToken = algoliaUserToken();

  return (
    <>
      <Configure
        distinct
        analytics={isTrackingEnabled}
        clickAnalytics
        userToken={userToken}
        {...props}
      />
      {children}
    </>
  );
};

export default ConfiguredConfigure;
